<template>
  <div class="account-subscription-tariff">
    <BasePreloader v-if="loading.availableTariffs" />

    <template v-else>
      <div
        v-if="!mdOrDown"
        class="account-subscription-tariff__description"
      >
        <div class="account-subscription-tariff__description-top">
          <div class="account-subscription-tariff__description-tariff-name">{{ $tAccountSubscription('tariff_name') }}</div>
        </div>

        <div class="account-subscription-tariff__description-list">
          <div
            v-for="(item, index) in descriptionItems"
            :key="index"
            class="account-subscription-tariff__description-list-item"
          >
            <SubscriptionTariffDescriptionItem :item="item" />
          </div>
        </div>
      </div>

      <div class="account-subscription-tariff__cards">
        <SubscriptionTariffCard
          v-for="(tariff, index) in availableTariffs"
          :key="index"
          :tariff="tariff"
          :description-items="descriptionItems"
          @purchase="onTariffPurchaseClick"
        />
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import windowSizeMixin from '../../../mixins/windowSizeMixin';
import SubscriptionTariffCard from '../../../components/accountSubscription/SubscriptionTariffCard';
import SubscriptionTariffDescriptionItem from '../../../components/accountSubscription/SubscriptionTariffDescriptionItem';

export default {
  name: 'AccountSubscriptionTariff',
  components: {
    SubscriptionTariffCard,
    SubscriptionTariffDescriptionItem,
  },
  mixins: [windowSizeMixin],
  computed: {
    ...mapGetters('accountSubscription', [
      'loading',
      'availableTariffs',
    ]),
    descriptionItems() {
      return [ // TODO translate
        {
          icon: { name: 'ico-file-outline', width: '1.2rem', height: '1.6rem' },
          title: this.$tAccountSubscription('vacancies_publication'),
          description: this.$tAccountSubscription('vacancies_publication_description'),
        },
        {
          icon: { name: 'ico-eye-eyelashes', width: '1.8rem', height: '1.5rem' },
          title: this.$tAccountSubscription('opening_contact_info'),
          description: this.$tAccountSubscription('opening_contact_info_description'),
        },
        {
          icon: { name: 'ico-arrow-up-underlines', width: '0.9rem', height: '2rem' },
          title: this.$tAccountSubscription('raising_vacancies_up'),
          description: this.$tAccountSubscription('raising_vacancies_up_description'),
        },
        {
          icon: { name: 'ico-fire', width: '1.3rem', height: '1.7rem' },
          title: this.$tAccountSubscription('hot_tag_on_vacancies'),
          description: this.$tAccountSubscription('hot_tag_on_vacancies_description'),
        },
        // { // TODO temporary hide
        //   icon: { name: 'ico-envelope', width: '1.5rem', height: '1.5rem' },
        //   title: this.$tAccountSubscription('automatic_mailing'),
        //   description: this.$tAccountSubscription('automatic_mailing_description'),
        // },
        {
          icon: { name: 'ico-wallet-2', width: '1.5rem', height: '1.2rem' },
          title: this.$tAccountSubscription('tariff_cost'),
        },
      ];
    },
  },
  created() {
    this.loadAvailableTariffs();
  },
  methods: {
    ...mapActions('accountSubscription', [
      'loadAvailableTariffs',
      'purchaseTariff',
    ]),

    onTariffPurchaseClick(tariff) {
      const onAccept = () => {
        this.purchaseTariff(tariff)
          .then(this.showSuccessPurchaseModal)
          .then(this.loadAvailableTariffs)
          .catch(() => {
            this.$vModal.open('warning', {
              title: this.$tAccountSubscription('tariff_purchase_error'),
              message: this.$tAccountSubscription('tariff_purchase_error_description'),
            });
          });
      };

      this.$vModal.open('confirm', {
        title: this.$tAccountSubscription('buy_tariff_q'),
        successBtnClass: 'base-btn--outline-blue',
        onAccept,
      });
    },
    showSuccessPurchaseModal() {
      this.$vModal.open('message', {
        contentStyle: {
          maxWidth: '42rem',
        },
        title: this.$tAccountSubscription('tariff_successfully_purchased'),
        message: this.$tAccountSubscription('tariff_successfully_purchased_description'),
        buttonCenter: true,
      });
    },
  },
};
</script>
